import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { House, UserCircle, Tag, Gear, ShieldStar, Storefront, UsersThree } from "@phosphor-icons/react";
import { useApp } from "@/context/AppContext";

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, user, shopEnabled, groupsEnabled, simpleMode } = useApp();
  if (simpleMode) return null;

  const items = [
    { path: "/dashboard", label: t("home"), Icon: House, id: "home" },
    { path: "/profile", label: t("myProfile"), Icon: UserCircle, id: "profile" },
    { path: "/tags", label: t("safeBuddies"), Icon: Tag, id: "tags" },
    ...(groupsEnabled ? [{ path: "/groups", label: t("groups"), Icon: UsersThree, id: "groups" }] : []),
    ...(shopEnabled ? [{ path: "/shop", label: t("shop"), Icon: Storefront, id: "shop" }] : []),
    { path: "/settings", label: t("settings"), Icon: Gear, id: "settings" },
    ...(user?.is_admin ? [{ path: "/admin", label: t("admin"), Icon: ShieldStar, id: "admin" }] : []),
  ];

  return (
    <nav className="absolute bottom-0 left-0 right-0 h-20 backdrop-blur-xl border-t border-[var(--app-border)] flex justify-around items-center px-2 z-50 rounded-t-3xl shadow-[0_-2px_16px_rgba(16,24,40,0.08)]" style={{ background: "color-mix(in srgb, var(--app-surface) 92%, transparent)" }}>
      {items.map(({ path, label, Icon, id }) => {
        const active = location.pathname === path;
        return (
          <button
            key={path}
            data-testid={`nav-tab-${id}`}
            onClick={() => navigate(path)}
            className="flex flex-col items-center justify-center gap-0.5 w-16 transition-transform active:scale-90"
          >
            <div className="p-1.5 rounded-xl" style={active ? { background: "color-mix(in srgb, var(--app-primary) 20%, transparent)", color: "var(--app-strong)" } : { color: "#71717a" }}>
              <Icon size={26} weight={active ? "fill" : "regular"} />
            </div>
            <span className="text-[10px] font-heading font-medium leading-tight" style={active ? { color: "var(--app-strong)" } : { color: "#71717a" }}>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
